import React, { useState, useEffect } from "react";
import { Layout, Input, Badge, Avatar, Space, Tooltip } from "antd";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  BellOutlined,
  UserOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import "../assets/css/Home.css";

const { Header } = Layout;

const Topbar = ({ collapsed, onToggle }) => {

const userStored = JSON.parse(localStorage.getItem("user"));

 


  return (
    <Header className="app-header">
      <div className="header-left">
        <button className="sider-toggle-btn" onClick={onToggle}>
          {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </button>
     
      </div>

      <div className="header-right">
  

        <Space size="large" align="center" className="header-actions">
        

          <div className="header-user">
            <div className="user-info">
              <span className="user-name">{userStored.nome}</span>
              
            </div>
            <Avatar icon={<UserOutlined />} />
          </div>
        </Space>
      </div>
    </Header>
  );
};

export default Topbar;
